import favicon from "/favicon.png";

const SidebarHeader = ({ isExpanded }) => {
  return (
    <div className="flex items-center px-3 h-16 flex-shrink-0 gap-3">
      <div className="w-9 h-9 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center flex-shrink-0 ring-1 ring-white/30 shadow-lg shadow-black/20">
        <img src={favicon} alt="logo" className="w-[22px] h-[22px]" />
      </div>
      {isExpanded && (
        <div className="flex flex-col overflow-hidden">
          <span className="text-white font-bold text-[14px] tracking-tight whitespace-nowrap leading-tight">
            HR Portal
          </span>
          <span className="text-[9.5px] text-white/40 font-semibold tracking-[0.18em] uppercase whitespace-nowrap">
            Management
          </span>
        </div>
      )}
    </div>
  );
};

export default SidebarHeader;
